import { demoModeAtom } from '@/global-store';
import { Box } from '@mui/material';
import { useAtom } from 'jotai';
import NavBadge from '../NavBadge';
import { useOrgBranding } from '@/branding/useOrgBranding';

function LogoSection({ dark }: { dark?: boolean }) {
  const [demoMode] = useAtom(demoModeAtom);
  const branding = useOrgBranding();

  // A branded header has a coloured background, so use the white logo/wordmark
  // for contrast regardless of the `dark` prop.
  const onColouredHeader = Boolean(branding);
  const useBlack = dark && !onColouredHeader;
  const logoSrc =
    branding?.customLogoUrl ??
    (useBlack
      ? 'https://assets.eye-able.com/dashboard-assets/icons/Icon_Dashboard_eye-able_black.svg'
      : 'https://assets.eye-able.com/dashboard-assets/icons/Icon_Dashboard_eye-able_white.svg');

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        whiteSpace: 'nowrap',
      }}
    >
      <Box
        aria-hidden='true'
        component='img'
        className='app-logo'
        src={logoSrc}
        sx={{
          height: 52,
          bgcolor: 'transparent',
        }}
      />
      {/* The eye-able wordmark only makes sense next to the eye-able logo. */}
      {branding?.customLogoUrl ? null : (
        <Box
          sx={[
            {
              whiteSpace: 'nowrap',
              position: 'relative',
              fontSize: '1.15rem',
              mr: 3,
            },
            {
              color: branding
                ? branding.brandTextColor
                : useBlack
                  ? '#000'
                  : '#fff',
            },
          ]}
        >
          <b>Eye-Able</b>

          <span style={{ position: 'absolute', right: '-12px', top: '-4px' }}>
            &#174;
          </span>
        </Box>
      )}
      {demoMode ? <NavBadge text='demo' /> : null}
    </Box>
  );
}

export default LogoSection;
